module.exports = __webpack_public_path__ + "static/media/pr.1d278b02.svg";